import React, { useState } from 'react';

const SlideModalEdit2 = ({
  isOpen,
  setIsOpen,
  handleInputChange,
  handleInputChangeEdit,
  handleFileChange,
  handleUpdateSlider,
  closeModal1,
  editData
}) => {
  const BASE_URL = `${process.env.REACT_APP_LINK}`;
  const [imagePreview, setImagePreview] = useState(null);
  const [imageError, setImageError] = useState("");
  const [linkError, setLinkError] = useState("");

  if (!isOpen) return null;

  const onFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedExtensions = ['jpeg', 'jpg', 'png', 'webp', 'avif'];
      const extension = file.name.split('.').pop().toLowerCase();
  
      if (!allowedExtensions.includes(extension)) {
        setImageError("Only jpeg, jpg, png, webp, avif formats are allowed.");
        setImagePreview(null);
        return;
      }
  
      if (file.size > 1024 * 1024) {
        setImageError("Image size must be less than 1MB.");
        setImagePreview(null);
        return;
      }
  
      setImageError("");
      setImagePreview(URL.createObjectURL(file));
      handleFileChange(e);
    }
  };
  

  const onSubmit = (e) => {
    e.preventDefault();

    if (editData.link && editData.link.trim() !== "") {
      const isValidLink = /^https?:\/\//.test(editData.link.trim());
      if (!isValidLink) {
        setLinkError("Link must start with http:// or https://");
        return;
      }
    }

    setLinkError("");

    if (imageError) return;

    handleUpdateSlider();
  };

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">Edit Slider</h2>
        <form className="oms-modal-form" onSubmit={onSubmit}>
          {/* Title */}
          <div className="oms-form-group">
            <label htmlFor="title" className="oms-form-label">Title</label>
            <input
              type="text"
              id="title"
              name="title"
              value={editData.name}
              onChange={handleInputChange}
              placeholder="Enter title"
              required
            />
          </div>

          {/* Link */}
          <div className="oms-form-group">
            <label htmlFor="link" className="oms-form-label">Link a Page</label>
            <input
              type="text"
              id="link"
              name="link"
              value={editData.link}
              onChange={handleInputChangeEdit}
              placeholder="Enter link"
            />
            {linkError && (
              <p style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{linkError}</p>
            )}
          </div>

          {/* Image Upload */}
          <div className="oms-form-group">
            <label htmlFor="image" className="oms-form-label">Upload Image</label>
            <input
              type="file"
              id="image"
              name="image"
              accept=".jpeg,.jpg,.png,.webp,.avif"
              onChange={onFileChange}
            />
            {imageError && (
              <p style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{imageError}</p>
            )}
            <div className="oms-image-preview" style={{ marginTop: '10px' }}>
              <img
                src={imagePreview || `${BASE_URL}/${editData.image}`}
                alt="Slider Preview"
                style={{ width: '100%', maxHeight: '150px', objectFit: 'contain' }}
              />
            </div>
          </div>

          {/* Actions */}
          <div className="oms-form-actions">
            <button type="button" onClick={closeModal1}>Cancel</button>
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SlideModalEdit2;
